import { useParams } from "react-router";
import { ReportDetailsPage } from "../report-details.page";
import { MissingReportId } from "./report-missing-id";
import { ReportErrorCard } from "./report-error-card";
import { ReportLoadingCard } from "./report-loading-card";
import { useReportDetails } from "../hooks/use-report-details";

export function ReportDetailsContainer() {
  const { uuid } = useParams();
  const reportDetails = useReportDetails(uuid);

  if (!uuid) {
    return <MissingReportId />;
  }

  if (reportDetails.error) {
    return (
      <>
        <title>❌ Report Details - Researchly</title>
        <ReportErrorCard error={reportDetails.error} />
      </>
    );
  }

  if (reportDetails.isLoading) {
    return (
      <>
        <title>Loading Report Details - Researchly</title>
        <ReportLoadingCard />
      </>
    );
  }

  return <ReportDetailsPage {...reportDetails} />;
}
